import { useAgentInsightsContext } from '../../contex/useAgentInsightsContext';
import { BackButton } from './BackButton';
import { HeaderContainer, HeaderTitle, TopRow } from './HeaderStyles';
import { TimeRangeFilter } from './TimeRangeFilter';

export const PublicInsightsHeader = () => {
    const { dateRange, setDateRange, isConversationView, from, to } = useAgentInsightsContext();

    return (
        <HeaderContainer>
            <TopRow>
                {isConversationView && <BackButton text="Conversation" />}
                {!isConversationView && <HeaderTitle>Insights</HeaderTitle>}

                <TimeRangeFilter dateRange={dateRange} from={from} to={to} onDateRangeChange={setDateRange} />
            </TopRow>
        </HeaderContainer>
    );
};
